module.exports = __webpack_public_path__ + "static/media/noclass11.f4fa0806.png";